/**
 * Created by Languagenut on 18/04/2019.
 */


import React  from 'react';
import {ProgressBar , ListGroup , Table , Badge , Form , Button , Card , Row , Col , Nav} from 'react-bootstrap'
import ReactDOM from "react-dom";
import Constants from '../../../constants.js';
import {StudentsService , AccountService} from '../../../services';
import {ImportStore , AccountStore} from '../../../store';
import Alert from '../../alert.js';
import FieldGroup from '../../FieldGroup.js'
import Translation from '../../../store/internationalization-store.js'

class UploadStudentsCompleted extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {
            errors:[],
            warnings:[],
            summary:[],
            loading:true
        };

        this.props.data.settings = {
            generateUsernames:false
        };
    }


    componentDidMount(){

        let csv    = this.props.data.csv || [];
        let fields = this.props.data.fields || {};

        StudentsService.import({} , fields , csv , this.props.data.headerRow);
    }

    componentWillReceiveProps(props){

    }

    componentWillMount(props){
        ImportStore.on(Constants.INSERT_STUDENT_IMPORT , ()=>{
            this.setState({
                loading:false,
                results:ImportStore.getImportResults(),
            });

            console.log(this.results)
        });

    }

    render(){

        if(this.state.loading) return <ProgressBar animated now={100} />


        return null;
    }


}


export default {
    name: function() {return Translation.get(1017 ,'Summary')},
    icon:<i class="fa-2x fas fa-file-alt"></i>,
    title:null,
    onSubmit: function (done){
        done();
    },
    component: UploadStudentsCompleted
}